// Estilos de las cajas de vista previa de imágenes (logos, íconos). Van inline para no
// depender de que el CSS scoped llegue al diálogo.

/** Caja con fondo de cuadrícula: los logos blancos o transparentes también se ven. */
export const PREVIEW_BOX_STYLE = {
  backgroundColor: '#fff',
  backgroundImage: [
    'linear-gradient(45deg, #d0d0d0 25%, transparent 25%)',
    'linear-gradient(-45deg, #d0d0d0 25%, transparent 25%)',
    'linear-gradient(45deg, transparent 75%, #d0d0d0 75%)',
    'linear-gradient(-45deg, transparent 75%, #d0d0d0 75%)'
  ].join(', '),
  backgroundSize: '10px 10px',
  backgroundPosition: '0 0, 0 5px, 5px -5px, -5px 0',
  overflow: 'hidden'
};

/** La imagen se ajusta a la caja sin deformarse. */
export const PREVIEW_IMG_STYLE = {
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain'
};
